/* Vadora scroll-reveal: fade + rise for [data-reveal] elements as they
   enter the viewport. Idempotent, resilient — never leaves content hidden.
   Works whether the page scrolls <html> or an inner wrapper (the base theme). */
(function () {
  if (window.__vadoraRevealInit) return;
  window.__vadoraRevealInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css =
    '[data-reveal]{opacity:0;transform:translateY(40px);' +
    'transition:opacity .8s cubic-bezier(.22,.61,.36,1),transform .8s cubic-bezier(.22,.61,.36,1);' +
    'transition-delay:var(--reveal-delay,0ms);will-change:opacity,transform;}' +
    '[data-reveal="section"]{transform:translateY(64px) scale(.95);' +
    'transition-duration:1.05s;}' +
    // inside a whole-section reveal, inner items ride along as one block
    '[data-reveal="section"] [data-reveal]{opacity:1!important;transform:none!important;transition:none!important;}' +
    '[data-reveal].is-revealed{opacity:1;transform:none;}' +
    '@media (prefers-reduced-motion: reduce){[data-reveal]{opacity:1!important;transform:none!important;transition:none!important;}}';
  var style = document.createElement('style');
  style.setAttribute('data-vadora-reveal', '');
  style.textContent = css;
  (document.head || document.documentElement).appendChild(style);

  function reveal(el) { el.classList.add('is-revealed'); }
  function pending() { return document.querySelectorAll('[data-reveal]:not(.is-revealed)'); }

  function revealInView(pad) {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    pending().forEach(function (el) {
      var r = el.getBoundingClientRect();
      // ignore not-yet-laid-out elements (0 height, stacked at top pre-image-load)
      if (r.height === 0 && r.top === 0) return;
      if (r.top < vh - (pad || 0) && r.bottom > -240) reveal(el);
    });
  }

  var designMode = (window.Shopify && window.Shopify.designMode) ||
    document.documentElement.classList.contains('shopify-design-mode');

  if (reduce || designMode || !('IntersectionObserver' in window)) {
    pending().forEach(reveal);
    // keep revealing sections added/edited in the theme editor
    if (designMode) {
      document.addEventListener('shopify:section:load', function () { pending().forEach(reveal); });
    }
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    },
    // negative bottom margin => fire when the element is ~12% into the viewport
    { rootMargin: '0px 0px -12% 0px', threshold: 0.01 }
  );

  function observeAll() { pending().forEach(function (el) { io.observe(el); }); }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { revealInView(60); ticking = false; });
  }

  function start() {
    // IntersectionObserver does the real work: it reports true post-layout
    // intersection and re-checks as images load and the page reflows, so it
    // never fires early for below-the-fold sections the way a scroll/rect
    // sweep at load would.
    observeAll();

    // capture:true so scroll from an inner wrapper (the base theme .page-wrapper) is heard
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Safety net — reveal anything IO missed, but only after layout has settled
    // (fonts/images in), and only elements actually near the viewport.
    setTimeout(function () { revealInView(0); }, 2000);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { revealInView(0); });
    }
    window.addEventListener('load', function () { setTimeout(function () { revealInView(0); }, 200); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function () {
    observeAll();
  });
})();
